import { CarouselItem } from '../../../core/models/item';
import { CategorySJsEnv } from './category_s_js_env';

/** 画面表示に必要なデータを管理する人 */
export class CategoryS {
  constructor(private model: CategorySJsEnv) {
    this.model = { ...model };
    // rrAreaに表示するItemsとTttleは外部公開APIとRRサーバで取得するのでここは空で定義
    this.model.rrAreaProfileCategorySExternalSite = {
      placementName: 'recomRR_s_01',
      displayCount: 3,
      rrAreaItems: [],
      rrAreaTitle: '',
      perView: 2
    };
    this.model.rrAreaProfileCategorySNormal = {
      placementName: 'recomRR_s_02',
      displayCount: 30,
      rrAreaItems: [],
      rrAreaTitle: '',
      perView: 5
    };
    this.model.rrAreaProfileCategorySLeftSide = {
      placementName: 'recomRR_s_03',
      rrAreaItems: [],
      rrAreaTitle: ''
    };

    this.model.rrAreaProfileCategorySSp = {
      placementName: 'recomRR_SP_s_01',
      displayCount: 4,
      rrAreaItems: [],
      rrAreaTitle: ''
    };
  }

  getModel(): CategorySJsEnv {
    return this.model;
  }

  setRrAreaDataCategorySExternalSite(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileCategorySExternalSite.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileCategorySExternalSite.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataCategorySNormal(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileCategorySNormal.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileCategorySNormal.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataCategorySLeftSide(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileCategorySLeftSide.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileCategorySLeftSide.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataCategorySSp(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileCategorySSp.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileCategorySSp.rrAreaTitle = rrAreaTitle;
  }
}
